import styled from '@emotion/styled';
import { css } from '@emotion/react';

const shouldForwardProp = (prop: string) => !prop.startsWith('$');

export const PageContent = styled.div`
  padding-top: 16px;

  @media (min-width: 769px) {
    padding: 16px;
  }
`;

export const ContentCard = styled('div', { shouldForwardProp })<{
  $expandWhenEmpty?: boolean;
}>`
  border: 1px solid #ebebeb;
  border-radius: 8px;
  background: #fff;
  overflow: visible;

  ${({ $expandWhenEmpty }) =>
    $expandWhenEmpty &&
    css`
      min-height: 460px;
    `}
`;

export const FiltersSection = styled.div`
  position: relative;
  z-index: 2;
`;

export const LegacyToolbar = styled.div`
  display: none;
`;

export const TableArea = styled('div', { shouldForwardProp })<{
  $expandWhenEmpty?: boolean;
}>`
  padding: 0 12px 12px;

  @media (max-width: 768px) {
    padding: 0 0 12px;
  }

  @media (min-width: 769px) {
    padding-top: 4px;
  }

  ${({ $expandWhenEmpty }) =>
    $expandWhenEmpty &&
    css`
      min-height: 280px;
    `}
`;

export const PaginationWrap = styled.div`
  padding: 8px 12px 16px;

  @media (max-width: 768px) {
    padding: 8px 16px 16px;
    display: flex;
    justify-content: center;
  }
`;

export const SelectionBarWrap = styled.div`
  padding: 0 12px 4px;

  @media (max-width: 768px) {
    padding: 0 16px 8px;
  }
`;

export const MobileTableWrap = styled.div`
  display: none;
`;
